import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Input } from '../components/ui/input';
import { Button } from '../components/ui/button';
import { Label } from '../components/ui/label';
import { Ship, Loader2, ArrowLeft } from 'lucide-react';
import { toast } from '../hooks/use-toast';

const AdminLogin = () => {
  const [u, setU] = useState('');
  const [p, setP] = useState('');
  const [busy, setBusy] = useState(false);
  const { login } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(u, p);
      toast({ title: 'Welcome back' });
      nav('/admin');
    } catch (err) {
      toast({ title: 'Invalid credentials', description: 'Please check your username and password.', variant: 'destructive' });
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#f6f8fa] flex items-center justify-center px-6 relative overflow-hidden">
      <div className="absolute inset-0 bg-cover bg-center opacity-20" style={{ backgroundImage: "url('https://images.unsplash.com/photo-1575501376367-6711b9b5756b?crop=entropy&cs=srgb&fm=jpg&q=85')" }} />
      <div className="absolute inset-0 bg-gradient-to-br from-[#304b71]/85 to-[#1e3454]/85" />

      <form onSubmit={submit} className="relative z-10 bg-white rounded-2xl shadow-2xl p-8 w-full max-w-md">
        <Link to="/" className="text-sm text-slate-500 hover:text-[#304b71] inline-flex items-center gap-1 mb-6"><ArrowLeft size={14} /> Back to site</Link>
        <div className="flex items-center gap-3 mb-6">
          <div className="w-12 h-12 rounded-full bg-[#304b71] text-white flex items-center justify-center"><Ship size={22} /></div>
          <div>
            <div className="font-serif text-2xl text-[#304b71]">Admin Login</div>
            <div className="text-xs text-slate-500">Get Nile Cruise dashboard</div>
          </div>
        </div>
        <div className="space-y-4">
          <div>
            <Label>Username</Label>
            <Input required value={u} onChange={(e) => setU(e.target.value)} className="mt-1.5 h-11" />
          </div>
          <div>
            <Label>Password</Label>
            <Input required type="password" value={p} onChange={(e) => setP(e.target.value)} className="mt-1.5 h-11" />
          </div>
          <Button type="submit" disabled={busy} className="w-full h-12 bg-[#304b71] hover:bg-[#6a8aa4] text-white">
            {busy ? <><Loader2 className="animate-spin mr-2" size={16} /> Signing in...</> : 'Sign in'}
          </Button>
        </div>
      </form>
    </div>
  );
};

export default AdminLogin;
